var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ShipDoc"}},[(_vm.page_data.length > 0)?_c('div',{staticClass:"row"},[_c('h1',[_vm._v("退/換貨政策")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.page_data[0].content)}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }